import React from "react";
import "../StoragePages.scss";
import { Page } from "components/core/Page";
import { StorageHeader } from "components/storages/Header";
import {
	BorderLine,
	Description,
	Heading,
	LastSearchBar,
	ListPoint,
	SubHeading
} from "components/storages/Common";
import { BUSINESS_STORAGE_DATA } from "components/storages/ContentData/BusinessStorageData";
import Container from "components/core/Page/Container";
import { ScrollToTop } from "components/core/ScrollToTop";
import { useSelector } from "react-redux";
import { PAGE_SUB_TYPES } from "@sparefoot/tracking-events";
import usePageViewTracking from "hooks/tracking/usePageViewTracking";

function BusinessStoragePage() {
	const baseUrl = useSelector((state) => state?.app?.baseUrl);
	usePageViewTracking(PAGE_SUB_TYPES.BUSINESS_LANDING);

	return (
		<Page
			className="storage-page"
			pageType={PAGE_SUB_TYPES.BUSINESS_LANDING}
			title="Business and Commercial Storage Units For Rent | Storage.com"
			description="1000s of business storage units by size, price & 
			amenities at Storage.com - the top self storage marketplace for your 
			commercial needs."
			canonical={`${baseUrl}/business-storage/`}
		>
			<Container>
				<StorageHeader heading="Find Business Storage Near You!" />
				<div className="all-sections">
					{BUSINESS_STORAGE_DATA?.map((item, index) => (
						<>
							<Heading content={item.heading} />
							<Description desc={item.description} />
							{item.description2 && (
								<>
									<br />
									<Description desc={item.description2} />
								</>
							)}
							{item.subHeadings &&
								item.subHeadings.map((subHeading) => (
									<>
										<SubHeading title={subHeading.title} />
										<Description desc={subHeading.desc} />
										<Description desc={subHeading.desc2} />
									</>
								))}
							<ul>
								{item.points &&
									item.points.map((point) => (
										<ListPoint
											title={point.title}
											desc={point.desc}
											bulletPoints={false}
										/>
									))}
							</ul>
							{item.description3 && (
								<>
									<br />
									<Description desc={item.description3} />
								</>
							)}

							{index !== BUSINESS_STORAGE_DATA.length - 1 && (
								<BorderLine />
							)}
						</>
					))}
					<LastSearchBar />
				</div>
			</Container>
			<ScrollToTop />
		</Page>
	);
}

export default BusinessStoragePage;
